var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 4.5,
    fill: "white",
    stroke: "#B5B5B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8398_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 26.3324H12.3334L24.5834 14.0824C24.8898 13.776 25.1329 13.4122 25.2987 13.0118C25.4646 12.6115 25.5499 12.1824 25.5499 11.7491C25.5499 11.3157 25.4646 10.8866 25.2987 10.4863C25.1329 10.0859 24.8898 9.72213 24.5834 9.41572C24.277 9.1093 23.9132 8.86624 23.5129 8.7004C23.1125 8.53457 22.6834 8.44922 22.2501 8.44922C21.8167 8.44922 21.3876 8.53457 20.9873 8.7004C20.5869 8.86624 20.2232 9.1093 19.9167 9.41572L7.66675 21.6657V26.3324Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.582L23.4167 15.2487",
    stroke: "#B5B5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8398_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModify);
export default __webpack_public_path__ + "static/media/ic-modify.c035ec9b1e48d5d7bc50832ae6940ced.svg";
export { ForwardRef as ReactComponent };